module.exports = __webpack_public_path__ + "static/media/applePay.319297af.png";